var ua = window.navigator.userAgent.toLocaleLowerCase();

var uaToScheme = {
    "lizhifm": "lizhifm://",
    "pplive": "pplive://",
    "lizhilive": 'lizhilive://',
    "pongpong": 'pongpong://',
    "lizhigame": 'lizhigame://',
    "zhiya":"zhiyaapp://",
    "tiya":"tiyaapp://",
    "bylive":"bylive://"
}
var appResult = {};
function getAppBuildNumber() {
    var r = /build\s*\d+/i;
    var matchArr = ua.match(r);

    if(matchArr && matchArr.length > 0) {
        return parseInt(matchArr[0].slice(5));
    } else {
        return -1;
    }
}

function isLizhiFM () {
    return /LizhiFM/i.test(ua);
}

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

function isAndroid() {
    return /android/i.test(ua);
}

function isIOS() {
    return /iphone|ipad/ig.test(ua) && !isAndroid();
}

function isWeixin() {
    return /micromessenger/i.test(ua);
}

function config(uas){
    if(uas){
        for(var k in uas){
            uaToScheme[k] = uas[k]
        }
    }
}

function getApp (){
    if(JSON.stringify(appResult) == "{}"){
        for(var k in uaToScheme){
            if(ua.indexOf(k) > -1){
                appResult = {
                    type:k,
                    protocol:uaToScheme[k],
                    isApp:true
                }
            }
        }
    }
    return appResult;
}




exports.isLizhiFM = isLizhiFM;
exports.isMobile = isMobile;
exports.isIOS = isIOS;
exports.isAndroid = isAndroid;
exports.isWeixin = isWeixin;
exports.uaString = ua;
exports.getAppBuildNumber = getAppBuildNumber;


exports.getApp = getApp;
exports.config = config;